<cxone-modal [headerTitle]="title" [allowClose]="allowClose" [saveDisabled]="false" [saveHidden]="false"
    (dismissed)="onDismiss()" (closed)="onDelete()" [saveLabel]="deleteLabel" [cancelLabel]="cancelLabel">
    <cxone-embedded-messages messageType="system-warning" [messageData]="deleteWarning" id="system-warning"></cxone-embedded-messages>
    <cxone-grid id="data-feed-dependency-grid" class="content-container" [gridOptions]="dataFeedDependencyGridOptions">
    </cxone-grid>
</cxone-modal>
